import React, { Component } from 'react';
import PropTypes from 'prop-types';
import AdvancedTable from './../AdvancedTable';
import './ListPanel.scss';

class ListPanel extends Component {
  static propTypes = {
    columnHeaders: PropTypes.array,
    rowData: PropTypes.array,
    getDataRow: PropTypes.func,
    className: PropTypes.string,
    dataLoading: PropTypes.bool,
    stickyHeader: PropTypes.bool,
    useSelectAll: PropTypes.bool,
    onSelectAll: PropTypes.func,
    isSelectAllDisabled: PropTypes.bool,
    isAllChecked: PropTypes.bool,
    totalCount: PropTypes.oneOfType([PropTypes.number, PropTypes.bool]),
    id: PropTypes.string,
    noDataText: PropTypes.string,
    headerGroupings: PropTypes.array,
    cellMinWidth: PropTypes.string,
    onRowClick: PropTypes.func,
    rowClassName: PropTypes.string,
    rowIndexPrefix: PropTypes.string,
    useSelectAccessor: PropTypes.func,
    isChecked: PropTypes.func,
    onCheck: PropTypes.func
  };

  static defaultProps = {
    stickyHeader: true
  };

  render() {
    const {
      columnHeaders,
      rowData,
      getDataRow,
      className,
      dataLoading,
      stickyHeader,
      useSelectAll,
      onSelectAll,
      isAllChecked,
      id,
      totalCount,
      noDataText,
      headerGroupings,
      cellMinWidth,
      isSelectAllDisabled,
      onRowClick,
      rowClassName,
      rowIndexPrefix,
      useSelectAccessor,
      isChecked,
      onCheck
    } = this.props;
    return (
      <AdvancedTable
        id={id}
        useSelectAll={useSelectAll}
        onSelectAll={onSelectAll}
        isAllChecked={isAllChecked}
        isSelectAllDisabled={isSelectAllDisabled}
        staticTable={true}
        columnHeaders={columnHeaders}
        rowData={rowData}
        getDataRow={getDataRow}
        className={className}
        dataLoading={dataLoading}
        stickyHeader={stickyHeader}
        totalCount={totalCount}
        noDataText={noDataText}
        headerGroupings={headerGroupings}
        cellMinWidth={cellMinWidth}
        onRowClick={onRowClick}
        rowClassName={rowClassName}
        rowIndexPrefix={rowIndexPrefix}
        useSelectAccessor={useSelectAccessor}
        isChecked={isChecked}
        onCheck={onCheck}
      />
    );
  }
}

export default ListPanel;
